import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-50 text-center p-4">
      <XCircle className="text-red-500 w-20 h-20 mb-4" />
      <h1 className="text-3xl font-bold text-red-600 mb-2">
        Payment not completed
      </h1>
      <p className="text-lg text-gray-700 mb-6">
        You canceled the payment or an error occurred. Please try again.
      </p>
      <div className="flex space-x-4">
        <button
          onClick={() => navigate("/")}
          className="bg-gray-300 hover:bg-gray-400"
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default CancelPage;
